<template>
    <div >
            <div class="flex p-5-9 m-b9" >
                <el-input
                        style="width: 220px"
                        size="mini"
                        class="input"
                        placeholder="搜索人名"
                        v-model="search"
                        clearable
                @change="searchFun">
                </el-input>
                <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>
                <el-button   @click="add"  size="mini"    :class="baseerp+'btn'" v-if="canEdit"> 新增</el-button>
<!--                <el-button  class="m-l14" :class="baseerp+'btn'"  size="mini" @click="eidtYcFun()" type="primary">查看异常</el-button>-->
            </div>
        <div class="flex jcsb m-b9">

            <div style="width: 240px;padding-right: 9px;">
                <div :class="baseerp+'div'"  :style="{height: tableHeight+'px',overflowY: 'auto',paddingTop:'6px'}">
                    <div v-for="(item,index) in searchPeople" :class="['fkbox' ,item.id==personid?'active':'']"  @click="chooseRmFun(item)">
<!--                        <i class="el-icon-collection-tag" ></i>-->
                        <div>{{item.name+'('+item.department+')'}}</div>
                    </div>
                </div>
                <el-pagination  style="margin-top: 10px;text-align: right"
                                small
                                @current-change="rmpageCurrentChange"
                                layout="prev, pager, next"
                                :current-page.sync="rmcurrentPage"
                                :total="rmtotal"
                                :page-size="rmpageSize"
                >
                </el-pagination>
            </div>
            <div  style="width: calc(100% - 240px)">
                <el-table stripe ref="table" :header-cell-style="{background:'#f5f7fa',color:'#000'}" size="mini" :height="tableHeight" border  :data="tableData" style="width: initial;">
                    <!--            <el-table-column type="selection" align="center"></el-table-column>-->
                    <!--            <el-table-column align="center" label="日期" prop="forDate">-->
                    <!--                <template class="flex"  slot-scope="scope">-->
                    <!--                    <el-date-picker class="m-l14" size="mini" v-model="scope.row.date" type="month" placeholder="选择日" format="yyyy-MM" value-format="yyyy-MM"></el-date-picker>-->

                    <!--                </template>-->
                    <!--            </el-table-column>-->
                    <el-table-column align="center" label="姓名" prop="userName" width="70" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="部门" prop="departmentName" width="90" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="状态" prop="stateTxt" width="70" show-overflow-tooltip>
                        <template class="flex"  slot-scope="scope">
                            <span :class="(scope.row.i_isconfirmed==-1||scope.row.i_isconfirmed==-2)?'red':(scope.row.i_isconfirmed==0)?'blue':'green'">{{scope.row.stateTxt}}</span>
                        </template>
                    </el-table-column>
<!--                    <el-table-column align="center" label="类型" prop="overtimeType" width="140" show-overflow-tooltip>-->
<!--                        <template class="flex"  slot-scope="scope">-->
<!--                            <el-radio-group v-model="scope.row.overtimeType" size="mini"  v-if="canEdit" @input="scope.row.change='change'">-->
<!--                                <el-radio :label=2  >调休</el-radio>-->
<!--                                <el-radio  :label=1 >薪资</el-radio>-->
<!--                            </el-radio-group>-->
<!--                            <span v-else>{{scope.row.overtimeType==1?'薪资':'调休'}}</span>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column align="center" label="开始时间" prop="startTime" show-overflow-tooltip>
                        <template class="flex"  slot-scope="scope">
                            <el-date-picker style="width: initial;" :picker-options="pickerOptions" v-if="canEdit" :default-value="data.dt_formonth" @change="startTimeChange($event,scope.row)" size="mini" v-model="scope.row.startTime" type="datetime" placeholder="选择开始时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                            <span v-else>{{scope.row.startTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="结束时间" prop="endTime" show-overflow-tooltip>
                        <template class="flex"  slot-scope="scope">
                            <el-date-picker style="width: initial;" v-if="canEdit"  :picker-options="pickerOptions" :default-value="data.dt_formonth" @change="endTimeChange($event,scope.row)" size="mini" v-model="scope.row.endTime" type="datetime" placeholder="选择结束时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                            <span v-else>{{scope.row.endTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="时长" prop="overtimeHour"  width="90" show-overflow-tooltip>
                        <template class="flex"  slot-scope="scope">
                            <el-input-number style="width: initial;" v-if="canEdit"  @change="overtimeHourChange($event,scope.row)"  :precision="1" v-model="scope.row.overtimeHour"  size="mini" :step="0.5" :controls="false" :step-strictly="true"></el-input-number>
                            <span v-else>{{scope.row.overtimeHour}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="事由" prop="vc_reason"  show-overflow-tooltip>
                        <template class="flex"  slot-scope="scope">
                            <el-input style="width: initial;" v-if="canEdit"  v-model="scope.row.vc_reason"  size="mini" ></el-input>
                            <span v-else>{{scope.row.vc_reason}}</span>

                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="是否补卡" prop="i_isbk" width="140" show-overflow-tooltip>
                        <template class="flex"  slot-scope="scope">
                            <el-radio-group ref="radio" v-removeAria v-model="scope.row.i_isbk" size="mini"  v-show="canEdit&&scope.row.i_handle_except" @input="scope.row.change='change'">
                                <el-radio :label=0  >否</el-radio>
                                <el-radio  :label=1 >是</el-radio>
                            </el-radio-group>
                            <span v-show="!(canEdit&&scope.row.i_handle_except)">{{scope.row.i_isbk==1?'是':'否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="异常原因" prop="vc_exception_note"  show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="操作(保存后生效)" width="115" >
                        <template class="flex"  slot-scope="scope">
                            <el-button type="text" icon="el-icon-minus"  style="color: red;font-weight: bold;font-size: 20px;padding:0;" v-if="canEdit" @click="delFun(scope.row,scope.$index)"></el-button>
                            <el-button type="text" icon="el-icon-document-copy" style="font-weight: bold;font-size: 20px;padding:0;"   v-if="canEdit" @click="copyFun(scope.row,scope.$index)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination  style="margin-top: 10px;text-align: right"
                                background
                                @current-change="pageCurrentChange"
                                layout="total,prev, pager, next"
                                :current-page.sync="currentPage"
                                :total="total"
                                :page-size="pageSize">
                </el-pagination>
            </div>
        </div>
        <div  class="center">
            <template v-if="data.i_state!==1" >
                <el-button type="primary" @click="editSave" :disabled="flow" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="edit" :disabled="flow" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
            </template>
<!--            <template v-if="data.i_state==1" >-->
<!--                <el-button type="primary" @click="editBkSave" :disabled="flow" :class="baseerp+'btn'" size="small" v-if="canBkEdit">保存补卡</el-button>-->
<!--                <el-button type="primary" @click="editBk" :disabled="flow" :class="baseerp+'btn'" size="small" v-if="!canBkEdit">编辑补卡</el-button>-->
<!--            </template>-->
<!--            <el-button type="warning" @click="flowSub" :disabled="flow" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
        <el-dialog title="查看异常"
                   width="95%"  :class="baseerp+'div'"
                   top="30px"
                   :visible.sync="ycdialogSub"
                   :close-on-click-modal="false"
                   @close="closeYcFun"
                    append-to-body>

            <yc-index :data="ycData" v-if="ycdialogSub" @close="closeYcFun" ></yc-index>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import YcIndex from './YcIndex'

    import {mapActions} from "vuex";
    const getYm=()=>{
        let newD=new Date();
        let y=newD.getFullYear();
        let m=newD.getMonth()+1;
            m=m>9? m : '0'+m;
        return y+'-'+m
    };
    export default {
        name: "jiaBan",
    components:{YcIndex},
        props:{
            data:{
                type:Object,
                required:true
            },
        },
        data(){
            return{
                baseerp:baseerp,
                search:'',
                searchname:'',
                searchPeople:[],
                disabled:false,
                tableHeight:0,//列表高度
                tableData:[],
                currentPage:1,
                pageSize:20,
                total:0,
                rmcurrentPage:1,
                rmpageSize:20,
                rmtotal:0,
                canEdit:false,
                canBkEdit:false,
                flow:false,
                back:'back',
                personid:null,
                department:null,
                delList:[],
                ycdialogSub:false,
                dif:0,
                pickerOptions:{

                },

            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted(){
            // this.$refs.radio.$children.forEach(item=>{
            //     item.$refs.radio.removeAttribute('aria-hidden')
            // })
            if(this.data.i_id!=0){
                this.overtimeList()
            }else{
                this.canBkEdit=true
                this.canEdit=true
            }
            this.searchUser()
            this.$nextTick(()=>{
                this.onResize();

            })
            let that=this
            this.pickerOptions={
                disabledDate(time){
                    let y=time.getFullYear();
                    let m=time.getMonth()+1;
                    m=m>9? m : '0'+m;
                    let ym=y+'-'+m;
                    if(ym==that.data.dt_formonth){
                        return false
                    }else{
                        return true
                    }
                }
            }
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-200
            },
            eidtYcFun(){
                this.ycdialogSub=true
                this.ycData={
                    type:'edit',
                    i_id:0,
                    dt_formonth:this.data.dt_formonth,
                }
            },
            closeYcFun(type='back',arr=[]){
                if(type=='save'){
                    // console.log(arr)
                    this.tableData=[...this.tableData,...arr]
                }
                this.ycData={}
                this.ycdialogSub=false
            },
            overtimeHourChange(e,row){
                row.change='change'
                if(this.dif&&this.dif<row.overtimeHour*60*60*1000){
                    this.$message.error('时间区间需大于等于时长')
                    row.overtimeHour=''
                }

            },
            startTimeChange(e,row){
                row.change='change';
                if(row.endTime){
                    let month=row.startTime&&row.startTime.substring(0,7)
                    if(month==this.data.dt_formonth){
                        let end=new Date(row.endTime+':00'),start=new Date(row.startTime+':00');
                            this.dif=end - start;
                        if( this.dif>24*60*60*1000|| this.dif<=0){
                            this.$message.error('时间区间需大于0小于等于24')
                            row.startTime=''
                        }else{
                            if(row.overtimeHour&&this.dif<row.overtimeHour*60*60*1000){
                                this.$message.error('时间区间需大于等于时长')
                                row.startTime=''
                            }
                        }
                    }else if(month){
                        row.startTime=''
                        this.$message.error('只能选择'+this.data.dt_formonth+'的时间区间')
                    }

                }
            },
            endTimeChange(e,row){
                row.change='change';
                if(row.startTime){
                    let month=row.endTime&&row.endTime.substring(0,7)
                        if(month==this.data.dt_formonth){
                        let end=new Date(row.endTime+':00'),start=new Date(row.startTime+':00');
                            this.dif=end - start;
                            if( this.dif>24*60*60*1000|| this.dif<=0){
                                this.$message.error('时间区间需大于0小于等于24')
                                row.endTime=''
                            }else{
                                if(row.overtimeHour&&this.dif<row.overtimeHour*60*60*1000){
                                    this.$message.error('时间区间需大于等于时长')
                                    row.endTime=''
                                }
                            }
                    }else  if(month){
                        row.endTime=''
                        this.$message.error('只能选择'+this.data.dt_formonth+'的时间区间')
                    }
                }
            },
            //名称搜索
            searchFun(val){
                this.currentPage=1
                this.searchUser()
                if(!this.canEdit)this.overtimeList()
            },
            //名字选择
            chooseRmFun(val){
                this.personid=val.id
                this.personname=val.name;
                this.department=val.department;
                if(!this.canEdit)this.overtimeList()

            },
            add(){
                if(this.personid){
                    this.tableData.push({
                        // userName:'',
                        startTime:'',
                        endTime:'',
                        overtimeHour:'',
                        overtimeType:2,
                        vc_lruname: sessionStorage.getItem("lruname"),
                        i_lruid:sessionStorage.getItem("userid"),
                        subId:0,
                        pid:0,
                        userName:this.personname,
                        userId:this.personid,
                        departmentName:this.department,
                        vc_reason:'',
                        i_isbk:0,
                    })
                }else{
                    this.$message.warning('请选择人员')
                }

            },
            edit(){
                this.canEdit=true
                this.canBkEdit=true
                this.currentPage=1
                if(this.data.i_id)this.overtimeList()

            },
            editSave(){
                if(this.data.vc_filenewname){
                    this.$confirm('继续保存,已生成的附件将作废,是否继续','提示',{
                        confirmButtonText:'继续',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(async()=>{
                        this.saveOvertime()

                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:'已取消'
                        })
                    })
                }else{
                    this.saveOvertime()

                }
            },
            editBk(){
                this.canBkEdit=true
                this.currentPage=1
                if(this.data.i_id)this.overtimeList()

            },
            editBkSave(){
                if(this.data.vc_bk_filenewname){
                    this.$confirm('继续保存,已生成的补卡附件将作废,是否继续','提示',{
                        confirmButtonText:'继续',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(async()=>{
                        this.saveOvertimeBk()

                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:'已取消'
                        })
                    })
                }else{
                    this.saveOvertimeBk()

                }
            },
            delFun(row,index){
                if(row.subId)this.delList.push(row.subId)
                this.month=row.startTime.substring(0,7)
                this.tableData.splice(index,1)
            },
            copyFun(row,index){
                if(this.personid){

                    let data={
                        // userName:'',
                        startTime:row.startTime,
                        endTime:row.endTime,
                        overtimeHour:row.overtimeHour,
                        overtimeType:row.overtimeType,
                        vc_reason:row.vc_reason,
                        vc_lruname: sessionStorage.getItem("lruname"),
                        i_lruid:sessionStorage.getItem("userid"),
                        subId:0,
                        pid:0,
                        userName:this.personname,
                        userId:this.personid,
                        departmentName:this.department,
                        change:'change',
                        i_isbk:row.i_isbk,
                    }
                    this.tableData.push(data)
                }else{
                    this.$message.warning('请选择人员')
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.overtimeList();

            },
            rmpageCurrentChange(val){
                this.rmcurrentPage=val;
                //调用列表接口
                this.searchUser();

            },
            //搜索查询
            async searchUser() {
                let params = {
                    // vc_search:this.search,
                    currentPage:this.rmcurrentPage,
                    pageSize: this.rmpageSize,
                    keyname:this.search,
                }
                let res = await API.searchUser(params);
                if (res.code == 1) {
                    this.searchPeople=res.data
                    this.rmtotal=res.total
                    // if (this.searchPeople.length==1){
                    //     this.personid= this.searchPeople[0].id
                    //     this.overtimeList()
                    //     this.$forceUpdate()
                    // }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async saveOvertime() {
                let list=this.tableData.filter(l=>l.change=='change'),cansave=true;
                for(let l of list){
                    if (!l.startTime||!l.endTime){
                        this.$message.error('请填写开始时间/结束时间');
                        cansave=false
                    };
                    if(!l.overtimeHour){
                        this.$message.error('请填写加班时长');
                        cansave=false
                    };
                };
                if(!cansave){
                    return
                }
                if(this.delList.length==0&&list.length==0){
                    this.$message.error('无更改数据');
                    return

                }
                if(list.length>0)this.month=list[0].startTime.substring(0,7)
                let params = {
                    dt_formonth:this.month,
                    delSubs:this.delList,
                    sub:list,
                    i_id:this.data.i_id,
                    i_isbk:0
                };
                // console.log(params,'params')
                // return
                this.flow=true
                this.canEdit=false
                this.canBkEdit=false

                let res = await API.saveOvertimeSq(params);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.back='save'
                    this.cancel()
                   // this.overtimeList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                    this.flow=false

                }
            },
            async saveOvertimeBk() {
                let list=this.tableData.filter(l=>l.change=='change'),cansave=true;
                for(let l of list){
                    if (!l.startTime||!l.endTime){
                        this.$message.error('请填写开始时间/结束时间');
                        cansave=false
                    };
                    if(!l.overtimeHour){
                        this.$message.error('请填写加班时长');
                        cansave=false
                    };
                };
                if(!cansave){
                    return
                }
                if(this.delList.length==0&&list.length==0){
                    this.$message.error('无更改数据');
                    return

                }
                let params = {
                    dt_formonth:this.data.dt_formonth,
                    delSubs:this.delList,
                    sub:list,
                    i_id:this.data.i_id
                };
                // console.log(params,'params')
                // return
                this.flow=true
                this.canEdit=false
                this.canBkEdit=false
                let res = await API.saveOvertimeBk(params);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.back='save'
                    this.cancel()
                   // this.overtimeList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                    this.flow=false

                }
            },
            async overtimeList(){
                this.delList=[]
                // if(this.listparamid){
                let param={
                    currentPage:this.currentPage,
                    pageSize: this.pageSize,
                    vc_search:this.canEdit?'':this.search,
                    i_type:2,
                    i_id:this.data.i_id

                };
                let res=await API.getOvertimeSqSubList(param);
                if(res.code==1){
                    this.tableData=res.data.list;
                    this.total=res.data.total;

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
                // }else{
                //     this.$message.warning('请选择产品')
                // }

            },
            cancel(){
                this.$emit('close',this.back)
            },
            async flowSub(item){
                this.flow=true
                this.$message.success('正在提交，请稍候')
                let param={
                    i_id:this.data.i_id,
                    i_fileid:this.data.i_fileid,
                    i_newname:this.data.i_filenewname,
                };
                let res=await API.getOvertimeSqPdf(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.back='save'
                    this.cancel()
                    this.flow=false
                }else if (res.code == -2) {
                    this.flow=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.flow=false
                    this.$message.error(res.message);
                }
            },
       }
    }
</script>

<style lang="scss" scoped>
    .red{
        color: red;
    }
    .green{
        color: green;
    }
    .blue{
        color: dodgerblue;
    }
.p14{
    padding: 14px;
}
    .m-l14{
        margin-left: 14px;
    }
    .m-b9{
        margin-bottom: 9px;
    }
    .datetxt{
        font-size: 14px;
        display: inline-block;
        width: 50px;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .jcsb{
        justify-content: space-between;
    }
    /deep/{
        .el-radio{
            margin-right: 7px !important;
        }
    }
    .center{
        text-align: center;
    }
    .ghwdiv{
        .active{
            background-color: var(--opacityghw);
        }
        i{
            color: var(--darkghw);
            padding-top: 3px;
            padding-right: 6px;
        }
    }
    .havaydiv{
        .active{
            background-color: var(--opacityhavay);
        }
        i{
            color: var(--darkhavay);
            padding-top: 3px;
            padding-right: 6px;
        }
    }
    .fkbox{
        padding: 5px 9px;
        cursor: pointer;
    }
    .p-5-9{
        padding: 5px 9px;

    }
    .flex{
        display: flex;

    }
    div{
        /*font-size: 12px;*/
        line-height: 1.5;
    }
</style>